import Sso from './components/Sso';


export const routes = [
    {
        path: '/sso',
        exact: true,
        component: Sso,
        name: 'Sso',
    }
];

